<template lang="html">
  <div>
    <div class="sign_header_top">
      <i @click="back">&#xe628;</i><header>累计签到天数</header>
      <div class="day_box">
        <span>{{datas.days}}</span>
      </div>
      <h3>{{datas.level}}</h3>
      <div class="sign_day">
        <ul>
           <li v-for="(i, index) in daysItem" :key="index" >
             <span :class="[i.isSign==1?'spanactive':'']"  v-if="index!=6">{{i.tday}}日</span>
             <span :class="[i.isSign==1?'spanactive':'']" v-if="index==6">今日</span>
             <em v-if="i.isSign==1">{{i.ward}}果实</em>
             <em v-if="i.isSign!=1">未签到</em>
           </li>
        </ul>
      </div>
    </div>
    <div v-show="!isSign" class="sign_button_box">
      <span @click="signIn">立即签到</span>
    </div>
    <div v-show="isSign" class="game_box" >
      <h2>大家都在玩</h2>
      <div class="game_cont">
        <div class="left" @click="toDial">
          <!-- 大转盘 -->
          <div class="img_box">
            <img src="./timg.jpg" alt="">
          </div>
          <span>大转盘</span>
        </div>
        <div class="right">
        <a href="http://bbs.jmgo.com/plugin.php?id=levpop:levpop">
          <!-- 摇一摇 -->
          <div class="img_box">
            <img src="./yimg.jpg" alt="">
          </div>
          <span>摇一摇</span>
          </a>
        </div>
      </div>
    </div>
    <div class="mood_box">
      <h2>签到心情</h2>
      <ul>
        <li v-for="(item, index) in record" :key="index">
          <img :src="item.qdxq" alt="">
          <div class="mood_right">
            <p>{{item.todaysay}}</p>
            <span>{{item.time}}</span>
          </div>
        </li>
      </ul>
    </div>
    <van-popup v-model="show">
      <div class="padding_div">
        <input class="signinput" type="text" name="" value="" v-model="signTxt" placeholder="填写签到心情">
        <van-button type="danger" size="large" @click="lijiSign">签到</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { Toast } from 'vant'
import { Popup } from 'vant'
import { Button } from 'vant'

Vue.use(Button)
Vue.use(Popup)
Vue.use(Toast)
export default {
  data() {
    return {
      daysItem:[{
          tday: '1',
          date:'',
          ward: '0',
          isSign:0,
        },
        {
          tday: '1',
          date:'',
          ward: '0',
          isSign:0,
        },
        {
          tday: '1',
          date:'',
          ward: '0',
          isSign:0,
        },
        {
          tday: '1',
          date:'',
          ward: '0',
          isSign:0,
        },
        {
          tday: '1',
          date:'',
          ward: '0',
          isSign:0,
        },
        {
          tday: '1',
          date:'2018-09-18',
          ward: '0',
          isSign:0,
        },{
          tday: '1',
          date:'2018-09-18',
          ward: '0',
          isSign:0,
        }],
      dataList: [],
      record: [],
      datas: [],
      isSign: false,
      signTxt: '',
      cur_time:0,
      show: false
    }
  },
  created() {
    this.getSignData()
  },
  methods: {
    getSignData(){
      utilAxios.get({
        url: '/new_api.php?module=dsu',
        method: 'GET',
        callback: (res) => {
         
          if(res.data.code=='100'){
            this.record = res.data.record
            this.datas = res.data
            if (res.data.qdstatus == 1) {
              this.isSign = true
            }
            this.cur_time=res.data.cur_time;

            this.daysItem.forEach((item,index)=>{
                let c_time=getDate(res.data.cur_time,6-index)
                this.daysItem[index].date=c_time.strtime
                this.daysItem[index].tday=c_time.days
            })
            
            res.data.record.forEach((item,index)=>{
                this.daysItem.forEach((item2,index2)=>{
                    if(item.time==item2.date){
                       this.daysItem[index2].isSign=1;
                       this.daysItem[index2].ward=item.lastreward

                    }
                })
            })
          }else{
            window.location.href="https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act="+escape('http://bbs.jmgo.com/dist/#/sign')
          }
          

        }
      })
    },
   
    signIn(){
      this.show = true
    },
    lijiSign() {
      const data = Qs.stringify({"formhash": this.datas.formhash,"message": this.signTxt,})
      utilAxios.formpost({
        url: '/new_api.php?module=dsu&operation=qiandao&qdxq=kx&qdmode=1',
        method: 'POST',
        data:data,
        callback: (res) => {
          if (res.data.code == 100) {
               Toast.success(res.data.msg)
                 this.show = false
                 this.getSignData()
             } else {
               Toast.fail(res.data.msg)
             }
        }
      })
    },
    back() {
      this.$router.go(-1)
    },
    toDial() {
      this.$router.push('/dial')
    }
  }
}
function getDate(time,days){
    let date=new Date(new Date(time)-days*24*3600*1000);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    let strtime=year+'-'+month+'-'+strDate
    let c_time={
      days:strDate,
      strtime:strtime
    }
    return c_time


}
</script>

<style lang="scss" scoped>
  .sign_header_top{
    height: 2.7rem;
    background: -webkit-linear-gradient(to bottom, #f35266, #f7852f);
    background: linear-gradient(to bottom, #f35266 , #f7852f);
    position: relative;
    i{
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: .44rem;
      height: .44rem;
      font-size: .18rem;
      text-align: center;
      line-height: .44rem;
      color: #fff;
      font-size: .25rem;
    }
    header{
      width: 100%;
      height: .44rem;
      text-align: center;
      line-height: .44rem;
      color: #FFF;
      font-size: .14rem;
    }
    .day_box{
      width: 100%;
      height: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        padding: .15rem .2rem;
        background: #fbe7eb;
        border-radius: .04rem;
        font-size: .35rem;
        color: #f35266;
      }
    }
    h3{
      text-align: center;
      color: #FFF;
    }
    .sign_day{
      width: 100%;
      margin-top: .4rem;
      ul{
        display: flex;
        li{
          flex: 1;
          height: .6rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          span{
            width: .3rem;
            height: .3rem;
            border-radius: 100%;
            border: 1px solid #fbedc3;
            line-height: .3rem;
            text-align: center;
            color: #fbedc3;
          }
          span.spanactive{
            background: #fbedc3;
            color: #f35266;
          }
          em{
            height: .3rem;
            line-height: .3rem;
            text-align: center;
            color: #fbedc3;
          }
        }
      }
    }
  }
  .game_box{
    padding: 0 .1rem;
    background: #FFF;
    height: 1.8rem;
    h2{
      height: .4rem;
      line-height: .4rem;
    }
    .game_cont{
      width: 100%;
      height: 1.4rem;
      display: flex;
      .left{
        flex: 1;
        .img_box{
          width: 100%;
          height: 1.0rem;
          display: flex;
          img{
            width: 1.0rem;
            margin: auto;
          }
        }
        span{
          display: block;
          text-align: center;
          line-height: .4rem;
        }
      }
      .right{
        a{
          color:#333;
        }
        
        flex: 1;
        .img_box{
          width: 100%;
          height: 1.0rem;
          display: flex;
          img{
            width: 1.0rem;
            margin: auto;
          }
        }
        span{
          display: block;
          text-align: center;
          line-height: .4rem;
        }
      }
    }
  }
  .mood_box{
    padding: 0 .1rem;
    background: #FFF;
    h2{
      height: .4rem;
      line-height: .4rem;
    }
    ul{
      border-top: 1px solid #EEE;
      li{
          display: flex;
          padding: .1rem 0;
          border-bottom: 1px solid #EEE;
          img{
            display: block;
            width: .4rem;
            height: .4rem;
            text-align: center;
            line-height: .4rem;
            color: #f7852f;
          }
          .mood_right{
            flex: 1;
            p{
              line-height: .15rem;
            }
            span{
              display: block;
              line-height: .2rem;
              text-align: right;
            }
          }
      }
    }
  }
  .sign_button_box{
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      display: block;
      width: 1rem;
      height: .4rem;
      background: red;
      text-align: center;
      line-height: .4rem;
      border-radius: .04rem;
      color: #fff;
    }
  }
  .padding_div{
    padding: .2rem;
    .signinput{
      margin: .1rem 0;
      height: .3rem;
      border: none;
      border:1px solid #eee;
      width: 2rem;
    }
    .van-button--large {
      width: 100%;
      height: 40px;
      line-height: 38px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Sign/Sign.vue